module.exports = __webpack_public_path__ + "img/Empty.bc2f9e29.jpg";